<template>
  <div class="index-container">
    <!-- 顶部导航栏 -->
    <div class="top-header">
      <div class="header-left" @click="goToSearch">
        <i class="el-icon-search"></i>
      </div>
      <div class="header-center">
        <h3>Jewelry Sales</h3>
      </div>
      <div class="header-right" @click="goToCart">
        <i class="el-icon-shopping-cart-full"></i>
      </div>
    </div>

    <!-- 钻石大图 -->
    <div class="diamond-banner">
      <img :src="bannerImage" alt="钻石" />
    </div>

    <!-- 功能按钮网格 -->
    <div class="menu-grid">
      <div 
        v-for="item in MenuList" 
        :key="item.name" 
        class="menu-item" 
        @click="navTo(item)"
      >
        <div class="menu-icon">
          <i :class="item.icon"></i>
        </div>
        <div class="menu-name">{{ item.name }}</div>
      </div>
      <!-- 语言切换按钮 -->
      <div class="menu-item language-switch-item">
        <div class="language-buttons">
          <button 
            class="lang-btn" 
            :class="{ active: currentLocale === 'en-US' }"
            @click.stop="switchLanguage('en-US')"
          >
            En
          </button>
          <button 
            class="lang-btn" 
            :class="{ active: currentLocale === 'zh-TW' }"
            @click.stop="switchLanguage('zh-TW')"
          >
            繁
          </button>
        </div>
        <div class="menu-name">{{ $t('common.languageSwitch') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiMenuList } from '@/api/index.js'
import { Loading } from 'element-ui'
import cookieOperation from '@/common/js/cookieOperation'

export default {
  name: 'Index',
  data() {
    return {
      userId: this.$store.state.userName,
      authList: [],
      isMobile: false,
      currentLocale: this.$i18n.locale,
      bannerImage: require('../assets/images/banner3.png'),
      MenuList: [
        { 
          name: this.$t('common.diamondSelect'), 
          icon: 'el-icon-goods', 
          path: '/phone/diamondShopSelect',
          color: '#409EFF'
        },
        { 
          name: this.$t('common.colorDiamondSelect'), 
          icon: 'el-icon-goods', 
          path: '/phone/diamondShopSelect',
          color: '#FF6B35'
        },
        { 
          name: this.$t('common.orderCenter'), 
          icon: 'el-icon-document-checked', 
          path: '/phone/myDiamondListMobile',
          color: '#409EFF'
        },
        { 
          name: this.$t('common.shoppingCart'), 
          icon: 'el-icon-shopping-cart-full', 
          path: '/phone/shoppingMobile',
          color: '#67C23A'
        },
        { 
          name: this.$t('common.personalCenter'), 
          icon: 'el-icon-user', 
          path: '/phone/personalInfo',
          color: '#FF6B35'
        },
      ],
    }
  },
  created() {
    this.currentLocale = this.$i18n.locale
    this.getUserInfo()
  },
  methods: {
    // 获取用户信息
    getUserInfo() {
      let _this = this
      // 检查是否有 access_token
      const accessToken = sessionStorage.getItem('access_token') || cookieOperation.cookie.get('access_token')
      
      if (!accessToken) {
        // 如果没有 token，跳转到登录页
        _this.$router.push({ path: '/login' })
        return
      }
      
      // 如果有 token，获取用户信息并继续初始化
      const userName = sessionStorage.getItem('userName') || cookieOperation.cookie.get('userName')
      const userType = sessionStorage.getItem('userType') || cookieOperation.cookie.get('userType')
      const userDept = sessionStorage.getItem('userDept') || cookieOperation.cookie.get('userDept')
      
      // 保存用户信息到 data 中（如果需要）
      _this.userId = userName
      
      // 继续执行其他初始化操作
      _this.checkMobile()
      _this.getMenuList()
    },
    checkMobile() {
      this.isMobile = !!navigator.userAgent.match(/(phone|pad|pod|iPhone|iPhone,iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      // 如果不是移动端，使用PC端路由
      if (!this.isMobile) {
        this.MenuList.forEach(item => {
          if (item.path === '/phone/diamondShopSelect') {
            item.path = '/shop/diamondShopList'
          } else if (item.path === '/phone/shoppingMobile') {
            item.path = '/shop/shopping'
          } else if (item.path === '/phone/myDiamondListMobile') {
            item.path = '/shop/myDiamondList'
          }
        })
      }
    },
    
    async getMenuList() {
      const params = new URLSearchParams({
        userName: this.userId || '',
        t_channel: 1
      })
      const res = await apiMenuList(params.toString()).catch(() => {})
      if (res && res.flag) {
        if (res.obj && res.obj.length) {
          res.obj.map(item => {
            this.authList.push(item.aliasName)
          })
        }
      }
    },
    
    navTo(item) {
      // 彩钻查询功能待开发（通过 path 判断，因为彩钻查询和白钻查询使用相同的 path）
      // 或者通过索引判断（第二个菜单项是彩钻查询）
      const colorDiamondIndex = 1
      const currentIndex = this.MenuList.findIndex(menuItem => menuItem === item)
      
      if (currentIndex === colorDiamondIndex) {
        this.$message({
          message: this.$t('developing') || '待开发中',
          type: 'info',
          duration: 2000
        })
        return
      }
      
      if (item.path) {
        this.$router.push(item.path)
      }
    },
    goToCart() {
      const cartPath = '/phone/shoppingMobile'
      this.$router.push(cartPath)
    },
    goToSearch() {
      const searchPath = '/phone/diamondShopSelect'
      this.$router.push(searchPath)
    },
    switchLanguage(locale) {
      if (this.currentLocale === locale) {
        return
      }

      const loadingInstance = Loading.service({
        lock: true,
        text: '语言切换中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      this.$i18n.locale = locale
      this.currentLocale = locale
      document.querySelector('html').setAttribute('lang', locale)
      localStorage.setItem('language', locale)

      // 更新菜单列表的文本
      this.MenuList[0].name = this.$t('common.diamondSelect')
      this.MenuList[1].name = this.$t('common.colorDiamondSelect')
      this.MenuList[2].name = this.$t('common.shoppingCart')
      this.MenuList[3].name = this.$t('common.orderCenter')
      this.MenuList[4].name = this.$t('common.personalCenter')

      setTimeout(() => {
        loadingInstance.close()
        this.$message({
          message: '切换成功',
          type: 'success',
          duration: 1500
        })
        // 强制更新视图
        this.$forceUpdate()
      }, 500)
    },
  }
}
</script>

<style lang="scss" scoped>
.index-container {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto; /* 允许整体滚动，避免 iOS Safari 底部内容被截断 */
  -webkit-overflow-scrolling: touch;
}

.top-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  background-color: #409EFF;
  padding: 0 15px;
  position: sticky;
  top: 0;
  z-index: 100;

  .header-left,
  .header-right {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #fff;
    font-size: 20px;
    transition: opacity 0.3s;

    &:active {
      opacity: 0.7;
    }
  }

  .header-center {
    flex: 1;
    text-align: center;

    h3 {
      margin: 0;
      color: #fff;
      font-size: 18px;
      font-weight: 500;
    }
  }
}

.diamond-banner {
  width: 100%;
  height: 30vh; // 占据屏幕高度的1/3
  position: relative;
  overflow: hidden;
  background-color: #000;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.menu-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 15px 12px;
  background-color: #fff;
  width: 100%;
  box-sizing: border-box;

  .menu-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 15px 8px;
    cursor: pointer;
    transition: all 0.3s;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    width: 100%;
    box-sizing: border-box;
    min-width: 0;

    &:active {
      transform: scale(0.95);
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
    }

    .menu-icon {
      width: 45px;
      height: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 8px;
      border-radius: 50%;
      background-color: #f0f9ff;
      flex-shrink: 0;

      i {
        font-size: 24px;
      }
    }

    // 为不同菜单项设置不同的图标颜色和背景色
    &:nth-child(1) .menu-icon {
      background-color: #e6f4ff;
      i {
        color: #409EFF;
      }
    }

    &:nth-child(2) .menu-icon {
      background-color: #fff3e6;
      i {
        color: #FF6B35;
      }
    }

    &:nth-child(3) .menu-icon {
      background-color: #f0f9e8;
      i {
        color: #67C23A;
      }
    }

    &:nth-child(4) .menu-icon {
      background-color: #e6f4ff;
      i {
        color: #409EFF;
      }
    }

    &:nth-child(5) .menu-icon {
      background-color: #fff3e6;
      i {
        color: #FF6B35;
      }
    }

    .menu-name {
      font-size: 13px;
      color: #333;
      text-align: center;
      font-weight: 500;
      word-break: break-word;
      line-height: 1.3;
      width: 100%;
    }
  }

  // 语言切换按钮样式
  .language-switch-item {
    .language-buttons {
      display: flex;
      gap: 0;
      justify-content: center;
      align-items: center;
      width: 100%;
      margin-bottom: 8px;

      .lang-btn {
        min-width: 45px;
        height: 30px;
        padding: 0 12px;
        border: 1px solid #409EFF;
        border-radius: 0;
        font-size: 13px;
        cursor: pointer;
        transition: all 0.3s;
        font-weight: 500;

        &:first-child {
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
          border-right: none;
        }

        &:last-child {
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
        }

        &:active {
          transform: scale(0.95);
        }

        // 默认样式：白色背景，蓝色文字
        background-color: #fff;
        color: #409EFF;

        // 激活状态：蓝色背景，白色文字
        &.active {
          background-color: #409EFF;
          color: #fff;
        }

        &:not(.active):hover {
          background-color: #f0f9ff;
        }
      }
    }
  }
}

// 响应式设计：在更大的屏幕上使用3列布局
@media (min-width: 768px) {
  .menu-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
    padding: 20px 15px;
  }

  .menu-item {
    padding: 20px 10px;

    .menu-icon {
      width: 50px;
      height: 50px;
      margin-bottom: 10px;

      i {
        font-size: 28px;
      }
    }

    .menu-name {
      font-size: 14px;
    }
  }

  .language-switch-item {
    .language-buttons {
      margin-bottom: 10px;

      .lang-btn {
        min-width: 50px;
        height: 32px;
        padding: 0 16px;
        font-size: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue